import styled, { css } from 'styled-components'
import { themeStyles } from '../../../styles/theme'

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1em;
`

export const StyledContent = styled.div`
  background: ${themeStyles.colors.lightGreys[1].main};
  border-radius: 8px;
  padding: 12px 15px;
`

export const StyledHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5em;

  ${({ expandable }) =>
    expandable &&
    css`
      cursor: pointer;
    `}
`

export const StyledBody = styled.div`
  height: 0;
  overflow-y: hidden;
  padding-top: 0;
  transition: 0.2s;
  line-height: 1.45em;
  white-space: pre-line;

  &.active {
    height: auto;
    overflow-y: visible;
    padding-top: 12px;
  }
`
